import { render, staticRenderFns } from "./downloadBili.vue?vue&type=template&id=73e5213e&scoped=true"
import script from "./downloadBili.vue?vue&type=script&lang=js"
export * from "./downloadBili.vue?vue&type=script&lang=js"
import style0 from "./downloadBili.vue?vue&type=style&index=0&id=73e5213e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e5213e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/drone/src/components/Header/index.vue').default})
